import { defaultTheme } from "./defaultTheme";

// Hazır temalar. Admin panelinden tek tıkla seçilebilir, sonra tek tek renkler değiştirilebilir.
export const presets = [
  {
    id: "usta",
    label: "Otogaz Mavisi",
    description: "Tabela ve logo ile aynı kimlik. Varsayılan tema.",
    theme: defaultTheme,
  },
  {
    id: "yesil",
    label: "Usta Yeşili",
    description: "Eski tema. LPG ve güven çağrışımı.",
    theme: {
      ...defaultTheme,
      preset: "yesil",
      colors: {
        ...defaultTheme.colors,
        primary: "#0E7C5B",
        accent: "#F2A900",
        dark: "#0B1220",
        bg: "#F6F8F7",
        border: "#E3E8E6",
      },
    },
  },
  {
    id: "lacivert",
    label: "Lacivert & Amber",
    description: "Kurumsal, sakin. Sıcak amber vurgular.",
    theme: {
      ...defaultTheme,
      preset: "lacivert",
      colors: {
        ...defaultTheme.colors,
        primary: "#1D4ED8",
        accent: "#F59E0B",
        dark: "#0F172A",
        bg: "#F5F7FB",
        border: "#E2E8F0",
      },
    },
  },
  {
    id: "kirmizi",
    label: "Servis Kırmızısı",
    description: "Klasik oto servis kimliği. Enerjik.",
    theme: {
      ...defaultTheme,
      preset: "kirmizi",
      colors: {
        ...defaultTheme.colors,
        primary: "#C2410C",
        accent: "#FACC15",
        dark: "#1C1917",
        bg: "#FAF8F6",
        border: "#E7E0DB",
      },
      fonts: { heading: "Space Grotesk", body: "IBM Plex Sans" },
      radius: 8,
    },
  },
  {
    id: "gece",
    label: "Gece",
    description: "Koyu zemin, yüksek kontrast.",
    theme: {
      ...defaultTheme,
      preset: "gece",
      colors: {
        primary: "#22C55E",
        accent: "#FBBF24",
        dark: "#05080F",
        bg: "#0B1220",
        surface: "#111A2E",
        text: "#F1F5F9",
        muted: "#94A3B8",
        border: "#1E2A44",
      },
      headerStyle: "dark",
    },
  },
];

export const getPreset = (id) => presets.find((p) => p.id === id);
